import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import commandsList from '../../commands.json';

@Component({
  selector: 'app-message-item',
  standalone: true,
  imports: [CommonModule, AvatarModule, TooltipModule, ButtonModule, TagModule
  ],
  templateUrl: './message-item.component.html',
  styleUrl: './message-item.component.css'
})
export class MessageItemComponent implements OnInit, AfterViewInit{
  commands: any[] = [];
  isMapUrl: boolean = false;
  @Input() msgData: any | undefined;

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.commands = commandsList.v2;
    this.isMapUrl = this.msgData.msg.includes('http://maps.google.com/maps?');
  }



  translateMsg(msg: string){
    let code = this.commands.find(c => msg.includes(c.code.substring(0, c.code.length - 1)));
    if (code)
      return code.name;
    else
      return msg;
  }

  getNameInitials(name: string): string {
    if (name === null)
      return '';
    if (name.includes(" ")) {
      var separated = name.split(" ");
      name = separated[0].charAt(0) + separated[1].charAt(0);
    }
    return name;
  }
}
